import { ContentService } from '@blk/cwp-ng-framework';
import { DcrKeyValue, ERROR_CODES, ErrorDCR } from '@ddt-web/config';
import * as isArray from 'lodash/isArray';
import * as isEmpty from 'lodash/isEmpty';

import { PopupDialogAction, PopupDialogActionOptions } from '../models';
import { ErrorObject } from '../models/error-object';

export class ErrorHandlerUtil {

	/**
	 * Method to be used in all applications error handlers to ensure the errors are handled by right error handlers.
	 *
	 * Errors to be handled as PopupErrorObject:
	 * - PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND and SECURITY_NOT_FOUND errors will be handled by MissingHoldingErrorHandlerService
	 * - HOLDINGS_TOTAL_WEIGHT_ERROR error will be handled by HoldingsTotalWeightErrorHandlerService
	 * - if responseJson has an errorCodes object, it is a portfolio with PORTFOLIO_NOT_FOUND error code which will be handled by NotFoundErrorHandlerService
	 *
	 * @param error error to be checked if it should be handled as PopupErrorObject
	 */
	public static shouldHandleErrorAsPopupErrorObject(error: any): boolean {
		return error instanceof ErrorObject &&
			(
				(!error.responseJson.allDataReturned && !isArray(error.responseJson.errorCodes) && !isEmpty(error.responseJson.errorCodes)) ||
				(error.responseJson.errorCodes instanceof Array && (
					error.responseJson.errorCodes.includes(ERROR_CODES.PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND) ||
					error.responseJson.errorCodes.includes(ERROR_CODES.HOLDINGS_TOTAL_WEIGHT_ERROR) ||
					error.responseJson.errorCodes.includes(ERROR_CODES.SERIALIZATION_LIMIT) ||
					error.responseJson.errorCodes.includes(ERROR_CODES.SECURITY_NOT_FOUND)
				))
			);
	}

	public static buildPopupAction(label: string, type: string, reload: boolean = false, actionClass?: string, description?: string): PopupDialogAction {
		return PopupDialogAction.create({
			label: label,
			type: type,
			reload: reload,
			actionClass: actionClass,
			description: description
		} as PopupDialogActionOptions);
	}

	public static getUserErrorMessage(
		detailedMessageTemplate: DcrKeyValue,
		missingDataMessageTemplate: DcrKeyValue,
		substitutions: Map<string, string>,
		isDataMissing: boolean,
		contentService: ContentService
	): string {
		return !isDataMissing ?
			contentService.getSubstitutedValuesString(
				detailedMessageTemplate.dcrKey as string,
				substitutions,
				detailedMessageTemplate.dcrValue
			) :
			contentService.getSubstitutedValuesString(missingDataMessageTemplate.dcrKey as string, substitutions, missingDataMessageTemplate.dcrValue);
	}

	public static createErrorContinueButton(contentService: ContentService): PopupDialogAction {
		return PopupDialogAction.create({
			label: contentService.get('ERROR_CONTINUE_LABEL', ErrorDCR.ERROR_CONTINUE_LABEL),
			type: 'continue',
			reload: false
		});
	}
}
